import { queryOptions } from "@tanstack/react-query";
import type { z } from "zod";
import { planResponseSchema, type SavePlanRequest } from "@amber/profiles/contracts";
import { profileKeys } from "@amber/profiles/ui";
import { POLL_MS, apiGet, apiPost } from "@amber/ui";
import {
  okResultSchema,
  planPreviewSchema,
  revisionResultSchema,
  type planPreviewRequestSchema,
} from "../../contracts/index";
import { collectionKeys } from "./keys";

type PlanPreviewRequest = z.infer<typeof planPreviewRequestSchema>;

export const planPreviewQuery = (request: PlanPreviewRequest, csrf: string | null) =>
  queryOptions({
    queryKey: collectionKeys.planPreview(request),
    queryFn: () => apiPost("/api/plans/preview", request, planPreviewSchema, csrf),
    staleTime: 10_000,
  });

export const personPlanQuery = (id: string) =>
  queryOptions({
    queryKey: profileKeys.plan(id),
    queryFn: ({ signal }) => apiGet(`/api/profiles/${encodeURIComponent(id)}/plan`, planResponseSchema, signal),
    refetchInterval: POLL_MS,
  });

export const sourcePlanQuery = (id: string) =>
  queryOptions({
    queryKey: collectionKeys.sourcePlan(id),
    queryFn: ({ signal }) =>
      apiGet(`/api/collection/sources/${encodeURIComponent(id)}/plan`, planResponseSchema, signal),
  });

export const planCommands = {
  save: (profileId: string, body: SavePlanRequest, csrf: string | null) =>
    apiPost(`/api/profiles/${encodeURIComponent(profileId)}/plan`, body, revisionResultSchema, csrf),
  pausePerson: (profileId: string, body: { reason: string }, csrf: string | null) =>
    apiPost(`/api/profiles/${encodeURIComponent(profileId)}/pause`, body, okResultSchema, csrf),
  resumePerson: (profileId: string, body: { reason: string; catch_up: boolean }, csrf: string | null) =>
    apiPost(`/api/profiles/${encodeURIComponent(profileId)}/resume`, body, okResultSchema, csrf),
};
